module.exports = __webpack_public_path__ + "static/media/main_banner_01.5aa1e801.png";